import { LoadingButton } from "@mui/lab";
import { Alert, Box, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  clearTrayState,
  createTrayThunk,
  updateTrayThunk,
} from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  number: yup.number().required("Please enter tray number").positive().min(1),
});
const CreateUpdateTray = ({ cabin_id, number, tray }) => {
  const formik = useFormik({
    initialValues: {
      number: tray ? tray.number : number ?? 1,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const _data = { ...data, cabin: cabin_id };
      //   console.log(_data);
      if (tray) {
        dispatch(updateTrayThunk({ id: tray.id, data: _data }));
      } else {
        dispatch(createTrayThunk(_data));
      }
    },
  });
  const vendingState = useSelector((state) => state.vending);

  useEffect(() => {
    dispatch(clearTrayState());
  }, []);
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          label="Enter tray number"
          variant="outlined"
          name="number"
          type="number"
          fullWidth
          sx={{ mt: 1 }}
          value={formik.values.number}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.number)}
          helperText={formik.errors.number}
          autoComplete="new-password"
          required
        />
        {(vendingState.updateTrayError || vendingState.createTrayError) && (
          <Alert sx={{ mt: 1 }} severity="error">
            Error occurred
          </Alert>
        )}
        {(vendingState.updateTraySuccess || vendingState.createTraySuccess) && (
          <Alert sx={{ mt: 1 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          loading={
            vendingState.createTrayLoading || vendingState.updateTrayLoading
          }
          variant="outlined"
          type="submit"
          sx={{ mt: 1 }}
        >
          {tray ? "Update" : "Create"}
        </LoadingButton>
      </form>
    </Box>
  );
};

export default CreateUpdateTray;
